"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MORNING_STAR_CATEGORY_KEY = 'base';
exports.MORNING_STAR_COMPONENT_KEY = 'morningStar';